/**
 * 맵 id 하나를 export 형식 층 목록 + CCTV 목록으로 로드한다.
 * ROI 편집·실시간 관제가 같은 훅으로 같은 도면을 본다.
 */
import { useEffect, useState } from 'react';
import mapDataService from '../../map-editor-shared/api/services/mapDataService';
import { savedRecordsToLevels } from './mapExport';
import { collectCameras, type SiteMapCamera, type SiteMapLevel } from './siteMapModel';

export interface SiteMapState {
  levels: SiteMapLevel[];
  cameras: (SiteMapCamera & { floor: string })[];
  loading: boolean;
  error: string | null;
}

export function useSiteMap(mapId: number | null, mapName = ''): SiteMapState {
  const [state, setState] = useState<SiteMapState>({ levels: [], cameras: [], loading: false, error: null });

  useEffect(() => {
    if (mapId === null) {
      setState({ levels: [], cameras: [], loading: false, error: null });
      return;
    }
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));
    mapDataService
      .getMapData(mapId)
      .then((res) => {
        if (cancelled) return;
        if (!res.success || !res.data?.length) {
          setState({ levels: [], cameras: [], loading: false, error: '저장된 맵 데이터가 없습니다.' });
          return;
        }
        const levels = savedRecordsToLevels(res.data, mapName || `map-${mapId}`);
        setState({ levels, cameras: collectCameras(levels), loading: false, error: null });
      })
      .catch((e: unknown) => {
        if (cancelled) return;
        setState({ levels: [], cameras: [], loading: false, error: e instanceof Error ? e.message : '맵을 불러오지 못했습니다.' });
      });
    return () => { cancelled = true; };
  }, [mapId, mapName]);

  return state;
}
